import { render, staticRenderFns } from "./vgSideBar.vue?vue&type=template&id=0d422b1e&v-slot%3Adefault=true&"
import script from "./vgSideBar.vue?vue&type=script&lang=js&"
export * from "./vgSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports